import fetchersRegistry from '@/components/Questionnaire/fetchersRegistry';
import {
    formFields,
    formFieldsForRepair,
    formFieldsForMoldAcceptance,
} from '../../components/CreateMoldOrder/formConfigs';
import { MoldOrderMainType, moldOrderMainTypes, MoldOrderStatus, MoldOrderType } from '../../types/mold';
import { AppState } from '../appState';
import { statusLabelsByCompany } from '../orderLabels';
import { ROUTES } from '@/constants/routes';

export default {
    appName: 'SBI',
    featureToggles: {
        production: {
            enableRepairMoldOrder: true,
            enableMajorRepair: true,
            enabledModifyOrder: true,
            enableMoldAcceptanceCreation: true,
            enableNewMoldWithReadyStatus: false,
            enabledGeneratePdfButton: true,
            enableMultiApprovers: false,
            enableShotCountLogPage: true,
            enableMoldGuides: false,
            enableServerSideMoldOrderList: false,
        },
        staging: {
            enableRepairMoldOrder: true,
            enableMajorRepair: true,
            enabledModifyOrder: true,
            enableMoldAcceptanceCreation: true,
            enableNewMoldWithReadyStatus: false,
            enabledGeneratePdfButton: true,
            enableMultiApprovers: false,
            enableShotCountLogPage: true,
            enableMoldGuides: false,
            enableServerSideMoldOrderList: true,
        },
        dev: {
            enableRepairMoldOrder: true,
            enableMajorRepair: true,
            enabledModifyOrder: true,
            enableMoldAcceptanceCreation: true,
            enableNewMoldWithReadyStatus: true,
            enabledGeneratePdfButton: true,
            enableMultiApprovers: true,
            enableShotCountLogPage: true,
            enableMoldGuides: false,
            enableServerSideMoldOrderList: true,
        }
    },
    mold: {
        statusLabelMapping: {
            active: 'พร้อมใช้งาน',
            in_servicing: 'กำลังล้าง',
            repairing: 'กำลังซ่อม',
            modifying: 'กำลังแก้ไข',
            eol: 'สิ้นสุดการใช้งาน',
            inactive: 'ไม่พร้อมใช้งาน',
            arriving: 'รอเข้าโรงงาน',
            attention_required: 'ต้องการการดูแล',
            released_to_external: 'ส่งออกแล้ว',
            pending_export: 'รอส่งออก',
        },
        formConfiguration: {
            part: [],
            general: [
                {
                    key: 'sbiId',
                    type: 'text',
                    label: 'รหัสแม่พิมพ์',
                    placeholder: 'กำหนดโดยระบบ',
                    required: false,
                    disabled: true,
                },
                {
                    key: 'moldNumber',
                    type: 'text',
                    label: 'แม่พิมพ์ลูกที่',
                    placeholder: 'ระบุแม่พิมพ์ลูกที่',
                    required: true,
                },
                {
                    key: 'customerId',
                    type: 'search_dropdown',
                    label: 'รหัสลูกค้า',
                    placeholder: 'เลือกชื่อลูกค้า',
                    options: [],
                    fetch: fetchersRegistry['customer.getOptions'],
                    required: true,
                    enforceDropdownSelection: true,
                    validationMessage: "กรุณาเลือกตัวเลือกที่ถูกต้องจากรายการ",
                    allowInvalidInput: false
                },
                {
                    type: 'select',
                    key: 'moldSource',
                    options: [],
                    fetch: fetchersRegistry['mold.moldSourceList'],
                    placeholder: 'เลือก Mold Source',
                    label: 'Mold Source',
                    required: true,
                },
                {
                    type: 'select',
                    key: 'moldType',
                    options: [],
                    fetch: fetchersRegistry['moldType'],
                    placeholder: 'เลือกประเภทแม่พิมพ์',
                    label: 'ประเภทของแม่พิมพ์',
                    required: true,
                },
                {
                    type: 'text',
                    key: 'makerName',
                    label: 'Mold Maker Name',
                    placeholder: 'ระบุชื่อผู้ผลิตแม่พิมพ์',
                    required: true,
                },
                {
                    type: 'select_with_other_and_custom',
                    key: 'extraAttributes.country',
                    label: 'Country',
                    placeholder: 'ระบุประเทศ',
                    options: [],
                    fetch: fetchersRegistry['mold.allCountries'],
                    required: true,
                },
                {
                    type: 'text',
                    key: 'cavity',
                    label: 'Cavity',
                    required: true,
                    placeholder: 'ระบุจำนวน Cavity',
                },
                {
                    type: 'select_with_other_and_custom',
                    key: 'machineSizeMin',
                    label: 'MC Size Min',
                    options: [],
                    fetch: fetchersRegistry['mold.mcSizeList'],
                    required: true,
                },
                {
                    type: 'select_with_other_and_custom',
                    key: 'machineSizeMax',
                    label: 'MC Size Max',
                    options: [],
                    fetch: fetchersRegistry['mold.mcSizeList'],
                    required: true,
                },
                {
                    type: 'search_dropdown',
                    key: 'partMatGrade',
                    label: "Part Material Grade",
                    placeholder: 'ระบุเกรดวัสดุของชิ้นส่วน',
                    options: [],
                    fetch: fetchersRegistry['mold.partMatGradeList'],
                    enforceDropdownSelection: true,
                    required: true,
                    allowCreateNewOption: true,
                    createOptionConfig: {
                        entityType: 'mold.partMatGradeList',
                        onCreateSuccess: (newOption) => {
                            console.debug('Successfully created new part material grade:', newOption);
                        }
                    }
                },
                {
                    type: 'number',
                    key: 'maxShotCount',
                    label: 'Mold การันตี',
                    placeholder: 'ระบุจำนวนแม่พิมพ์การันตี',
                    required: true,
                },
                {
                    type: 'select',
                    key: 'surfaceFinish',
                    label: 'Surface Finish',
                    options: [],
                    fetch: fetchersRegistry['mold.surfaceFinish'],
                    placeholder: 'เลือก Surface Finish',
                    required: true,
                },
                {
                    type: 'text',
                    key: 'extraAttributes.textureNumber',
                    label: 'Texture Number',
                    placeholder: 'ระบุ Texture Number',
                    required: false,
                    showIf: (formData) => formData.surfaceFinish === 'Texture',
                }
            ],
            insert: [
                {
                    type: 'toggle',
                    key: 'insertEngraving',
                    label: 'Insert /Engraving',
                    required: false,
                },
                {
                    key: 'insertChangeType',
                    label: 'ลักษณะการเปลี่ยน Insert',
                    type: 'select_with_other_and_custom',
                    options: [],
                    fetch: fetchersRegistry['mold.insertChangeType'],
                    required: false,
                },
            ],
        },
        displayFieldGroups: [
            {
                key: 'general',
                label: 'ข้อมูลทั่วไป',
                fields: [
                    {
                        key: 'sbiId',
                        type: 'text',
                        label: 'รหัสแม่พิมพ์',
                        required: true,
                        disabled: true,
                    },
                    {
                        key: 'moldNumber',
                        type: 'text',
                        label: 'แม่พิมพ์ลูกที่',
                        required: true,
                    },
                    {
                        key: 'customerId',
                        type: 'search_dropdown',
                        label: 'รหัสลูกค้า',
                        placeholder: 'เลือกชื่อลูกค้า',
                        options: [],
                        fetch: fetchersRegistry['customer.getOptions'],
                        required: true,
                        enforceDropdownSelection: true,
                        validationMessage: "กรุณาเลือกตัวเลือกที่ถูกต้องจากรายการ",
                        allowInvalidInput: false
                    },
                    {
                        type: 'text',
                        key: 'revision',
                        label: 'Revision',
                        required: true,
                        disabled: true,
                    },
                    {
                        type: 'select',
                        key: 'moldType',
                        options: [],
                        fetch: fetchersRegistry['moldType'],
                        placeholder: 'เลือกประเภทแม่พิมพ์',
                        label: 'ประเภทของแม่พิมพ์',
                        required: true,
                    },
                    {
                        type: 'select',
                        key: 'moldSource',
                        options: [],
                        fetch: fetchersRegistry['mold.moldSourceList'],
                        placeholder: 'เลือก Mold Source',
                        label: 'Mold Source',
                        required: true,
                    },
                    {
                        type: 'text',
                        key: 'cavity',
                        label: 'Cavity',
                        required: false,
                    },
                    {
                        type: 'text',
                        key: 'makerName',
                        label: 'Mold Maker Name',
                        placeholder: 'ระบุชื่อผู้ผลิตแม่พิมพ์',
                        required: true,
                    },
                    {
                        type: 'select_with_other_and_custom',
                        key: 'extraAttributes.country',
                        label: 'Country',
                        placeholder: 'ระบุประเทศ',
                        options: [],
                        fetch: fetchersRegistry['mold.allCountries'],
                        required: true,
                    },
                    {
                        type: 'select',
                        key: 'plate',
                        label: 'Plate',
                        options: [],
                        fetch: fetchersRegistry['plateType'],
                        placeholder: 'เลือก Plate Type',
                        required: false,
                    },
                    {
                        type: 'select',
                        key: 'gateType',
                        options: [],
                        fetch: fetchersRegistry['gateType'],
                        placeholder: 'เลือก Gate Type',
                        label: 'Gate Type',
                        required: true,
                    },
                    {
                        type: 'toggle',
                        key: 'delayGate',
                        label: 'Delay Gate',
                        required: false,
                    },
                    {
                        type: 'toggle',
                        key: 'hotRunner',
                        label: 'Hot Runner',
                        required: false,
                    },
                    {
                        key: 'hotRunnerType',
                        label: 'Hot Runner Type',
                        options: [],
                        fetch: fetchersRegistry['mold.hotRunnerTypeList'],
                        required: false,
                        type: 'select_with_other_and_custom',
                    },
                    {
                        key: 'hotRunnerBrand',
                        label: 'Hot Runner Brand',
                        required: false,
                        type: 'text',
                    },
                    {
                        key: 'qtyZoneHr',
                        label: "Q'ty Zone HR",
                        required: false,
                        type: 'text',
                    },
                    {
                        key: 'partMatGrade',
                        label: "Part Material Grade",
                        placeholder: 'ระบุเกรดวัสดุของชิ้นส่วน',
                        required: true,
                        type: 'search_dropdown',
                        options: [],
                        fetch: fetchersRegistry['mold.partMatGradeList'],
                        enforceDropdownSelection: true,
                        allowCreateNewOption: true,
                        createOptionConfig: {
                            entityType: 'mold.partMatGradeList',
                        }
                    },
                    {
                        type: 'select',
                        key: 'surfaceFinish',
                        label: 'Surface Finish',
                        options: [],
                        fetch: fetchersRegistry['mold.surfaceFinish'],
                        placeholder: 'เลือก Surface Finish',
                        required: true,
                    },
                    {
                        type: 'text',
                        key: 'extraAttributes.textureNumber',
                        label: 'Texture Number',
                        placeholder: 'ระบุ Texture Number',
                        required: false,
                        showIf: (formData: any) => formData.surfaceFinish === 'Texture',
                    },
                    {
                        key: 'remarks',
                        label: 'จุดที่ต้องระวัง',
                        required: false,
                        type: 'textarea',
                    },
                ],
                uiConfig: {
                    icon: 'Info',
                    showShotCountBar: true,
                }
            },
            {
                key: 'shotCount',
                label: 'จำนวนชอต',
                fields: [
                    {
                        key: 'cycleShotCount',
                        label: 'ชอตสะสมจากระบบในรอบล้าง',
                        required: false,
                        type: 'number',
                        disabled: true,
                        // Normally reset only by completing an overhaul order; admins may
                        // correct it manually (e.g. overhaul done but order was rejected).
                        enabledForRoles: ['ADMIN'],
                    },
                    {
                        key: 'shotCount',
                        label: 'ชอตสะสมจากระบบ',
                        required: false,
                        type: 'number',
                    },
                    {
                        key: 'physicalShotCount',
                        label: 'ชอตสะสมของเคาน์เตอร์แม่พิมพ์',
                        required: false,
                        type: 'number',
                    },
                    {
                        type: 'number',
                        key: 'servicingAlertShotThreshold',
                        label: 'ชอตเตือนเซอร์วิส',
                        required: true,
                    },
                    {
                        type: 'number',
                        key: 'servicingMaxShotThreshold',
                        label: 'ชอตที่ต้องเซอร์วิส',
                        required: true,
                    },
                    {
                        type: 'number',
                        key: 'maxShotCount',
                        label: 'Mold การันตี',
                        required: true,
                    },
                ],
                uiConfig: {
                    icon: 'FileDigitIcon',
                    showShotCountBar: true,
                }
            },
            {
                key: 'dimensions',
                label: 'ขนาด',
                fields: [
                    {
                        type: 'number',
                        key: 'width',
                        label: 'Width',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'height',
                        label: 'Height',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'length',
                        label: 'Length',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'weight',
                        label: 'Mold Weight',
                        required: false,
                    },
                    {
                        type: 'select_with_other_and_custom',
                        key: 'machineSizeMin',
                        label: 'MC Size Min',
                        options: [],
                        fetch: fetchersRegistry['mold.mcSizeList'],
                        required: false,
                    },
                    {
                        type: 'select_with_other_and_custom',
                        key: 'machineSizeMax',
                        label: 'MC Size Max',
                        options: [],
                        fetch: fetchersRegistry['mold.mcSizeList'],
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'locatedRingOd',
                        label: 'Located Ring O.D. (ขนาด OD)',
                        required: false,
                    },
                    {
                        type: 'number',
                        key: 'nozzleSr',
                        label: 'Nozzle SR (R ของ Nozzle)',
                        required: false,
                    }
                ],
                uiConfig: {
                    icon: 'Box',
                    showShotCountBar: false,
                }
            },
            {
                key: 'insert',
                label: 'Insert',
                fields: [
                    {
                        type: 'toggle',
                        key: 'insertEngraving',
                        label: 'Insert /Engraving',
                        required: false,
                    },
                    {
                        type: 'select_with_other_and_custom',
                        key: 'insertChangeType',
                        label: 'ลักษณะการเปลี่ยน Insert',
                        options: [],
                        fetch: fetchersRegistry['mold.insertChangeType'],
                        required: false,
                    }
                ],
                uiConfig: {
                    icon: 'PocketKnife',
                    showShotCountBar: false,
                }
            },
            {
                key: 'location',
                label: 'ที่ตั้ง',
                fields: [
                    {
                        type: 'text',
                        key: 'currentLocation',
                        label: 'ที่อยู่แม่พิมพ์',
                        required: false,
                    },
                    {
                        type: 'select_with_other_and_custom',
                        key: 'storageLocation',
                        label: 'ที่เก็บ',
                        fetch: fetchersRegistry['locationStorage'],
                        required: false,
                    },
                    {
                        type: 'text',
                        key: 'assetNoCustomer',
                        label: 'Asset NO Customer',
                        required: false,
                    }
                ],
                uiConfig: {
                    icon: 'MapPin',
                    showShotCountBar: false,
                }
            },
        ],
        displayFields: {
            primaryField: 'sbiId',
            secondaryField: 'productParts'
        }
    },
    moldOrders: {
        maintenance: {
            title: 'ล้างแม่พิมพ์',
            orderTemplateVersion: '1.3',
            formConfigs: formFields,
            checkForFormCompletion: false,
            moldOrderMainTypes: moldOrderMainTypes,
            moldOrderTypes: [
                MoldOrderType.ALL_STORE,
                MoldOrderType.ALL_PRODUCTION,
                MoldOrderType.WAITING,
                MoldOrderType.STORE_ORDER_COMPLETE,
                MoldOrderType.STORE_CLOSE_MOLD,
                MoldOrderType.STORE_EOL,
            ],
            isEnable: true,
            creationConfig: {
                allowedStatuses: ['active'],
            },
            statusMapping: statusLabelsByCompany.sbi.maintenance,
            disallowSetNextAssignee: {
                all: [
                    MoldOrderStatus.PICK_UP,
                ]
            },
            colorCodeMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'blue',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'blue',
                    [MoldOrderStatus.PICK_UP]: 'gray',
                    [MoldOrderStatus.IN_PROGRESS]: 'amber',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'gray',
                    [MoldOrderStatus.REPORTER_CONFIRM]: 'gray',
                    [MoldOrderStatus.COMPLETED]: 'green',
                    [MoldOrderStatus.DONE]: 'green',
                    [MoldOrderStatus.END_REJECTED]: 'red',
                }
            },
            actionButtonMapping: {
                [MoldOrderStatus.PENDING_ACKNOWLEDGE]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'รับใบงาน',
                    buttons: [
                        'PrioritizeMoldOrder',
                    ],
                },
                [MoldOrderStatus.PICK_UP]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ล้างแม่พิมพ์',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.IN_PROGRESS]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.SUPERVISOR_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.REPORTER_CONFIRM]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
            },
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'FileText',
                    [MoldOrderStatus.PICK_UP]: 'Clock',
                    [MoldOrderStatus.IN_PROGRESS]: 'Cog',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.REPORTER_CONFIRM]: 'FileCheck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                },
            },
            uiConfig: {
                icon: {
                    name: 'ShieldHalf',
                    source: 'lucide',
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-blue-500 to-indigo-600',
                    textColor: 'text-white',
                    borderColor: 'border-blue-200',
                    shadow: 'shadow-lg shadow-blue-200/50',
                },
                colorCode: 'blue',
            }
        },
        repair: {
            title: 'ซ่อม/Modify',
            orderTemplateVersion: '1.1',
            formConfigs: formFieldsForRepair,
            checkForFormCompletion: false,
            creationConfig: {
                allowedStatuses: ['active', 'in_maintenance', 'in_repair', 'in_export', 'in_servicing'],
                featureToggle: 'enableRepairMoldOrder',
                customDisabledMessage: 'ฟีเจอร์ยังไม่เปิดใช้งาน',
            },
            moldOrderMainTypes: [
                {
                    value: MoldOrderMainType.REPAIR_MINOR,
                    label: 'ซ่อมหน้าเครื่อง',
                    subTypes: [
                        MoldOrderType.REPAIR_MINOR
                    ]
                },
                {
                    value: MoldOrderMainType.REPAIR_MAJOR,
                    label: 'ซ่อมทั่วไป',
                    subTypes: [
                        MoldOrderType.REPAIR_MAJOR
                    ]
                },
                {
                    value: MoldOrderMainType.MODIFY,
                    label: 'Modify แม่พิมพ์',
                    subTypes: [
                        MoldOrderType.MODIFY
                    ]
                }
            ],
            moldOrderTypes: [
                MoldOrderType.REPAIR_MINOR,
                MoldOrderType.REPAIR_MAJOR,
                MoldOrderType.MODIFY,
            ],
            isEnable: 'enableRepairMoldOrder',
            statusMapping: statusLabelsByCompany.sbi.repair,
            disallowSetNextAssignee: {
                all: [
                    MoldOrderStatus.PENDING_REPAIR,
                ]
            },
            colorCodeMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'blue',
                    [MoldOrderStatus.REPORTER_FILL_FORM]: 'blue',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'blue',
                    [MoldOrderStatus.ASSESSMENT]: 'amber',
                    [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: 'gray',
                    [MoldOrderStatus.PENDING_REPAIR]: 'gray',
                    [MoldOrderStatus.REPAIR_IN_PROGRESS]: 'amber',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'gray',
                    [MoldOrderStatus.REPORTER_REVIEW]: 'gray',
                    [MoldOrderStatus.PE_RESULT_APPROVAL]: 'gray',
                    [MoldOrderStatus.COMPLETED]: 'green',
                    [MoldOrderStatus.DONE]: 'green',
                    [MoldOrderStatus.END_REJECTED]: 'red',
                }
            },
            actionButtonMapping: {
                [MoldOrderStatus.REPORTER_FILL_FORM]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ]
                },
                [MoldOrderStatus.PENDING_ACKNOWLEDGE]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'รับใบงาน',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'PrioritizeMoldOrder',
                        'ViewQuestionnaire',
                    ]
                },
                [MoldOrderStatus.ASSESSMENT]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ]
                },
                [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'FillQuestionnaire',
                    ]
                },
                [MoldOrderStatus.PENDING_REPAIR]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ซ่อมแม่พิมพ์',
                    buttons: [
                        'ViewQuestionnaire',
                    ]
                },
                [MoldOrderStatus.REPAIR_IN_PROGRESS]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ]
                },
                [MoldOrderStatus.SUPERVISOR_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ]
                },
                [MoldOrderStatus.REPORTER_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'FillQuestionnaire',
                    ]
                },
                [MoldOrderStatus.PE_RESULT_APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ]
                },
            },
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.REPORTER_FILL_FORM]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'FileText',
                    [MoldOrderStatus.ASSESSMENT]: 'HardHatIcon',
                    [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PENDING_REPAIR]: 'FileText',
                    [MoldOrderStatus.REPAIR_IN_PROGRESS]: 'Cog',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.REPORTER_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.PE_RESULT_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                },
            },
            uiConfig: {
                icon: {
                    name: 'Wrench',
                    source: 'lucide',
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
                    textColor: 'text-white',
                    borderColor: 'border-amber-200',
                    shadow: 'shadow-lg shadow-amber-200/50',
                },
                colorCode: 'yellow',
            }
        },
        modify: {
            title: 'Modify',
            orderTemplateVersion: '1.1',
            formConfigs: formFieldsForRepair,
            checkForFormCompletion: false,
            creationConfig: {
                allowedStatuses: ['active'],
                featureToggle: 'enabledModifyOrder',
                customDisabledMessage: 'ฟีเจอร์ยังไม่เปิดใช้งาน',
            },
            moldOrderMainTypes: [
                {
                    value: MoldOrderMainType.REPAIR_MINOR,
                    label: 'ซ่อมหน้าเครื่อง',
                    subTypes: [
                        MoldOrderType.REPAIR_MINOR
                    ]
                },
                {
                    value: MoldOrderMainType.REPAIR_MAJOR,
                    label: 'ซ่อมทั่วไป',
                    subTypes: [
                        MoldOrderType.REPAIR_MAJOR
                    ]
                },
                {
                    value: MoldOrderMainType.MODIFY,
                    label: 'Modify แม่พิมพ์',
                    subTypes: [
                        MoldOrderType.MODIFY
                    ]
                }
            ],
            moldOrderTypes: [
                MoldOrderType.REPAIR_MINOR,
                MoldOrderType.REPAIR_MAJOR,
                MoldOrderType.MODIFY,
            ],
            isEnable: 'enableRepairMoldOrder',
            statusMapping: statusLabelsByCompany.sbi.modify,
            disallowSetNextAssignee: {
                all: [
                    MoldOrderStatus.PENDING_REPAIR,
                ]
            },
            colorCodeMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'blue',
                    [MoldOrderStatus.REPORTER_FILL_FORM]: 'blue',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'blue',
                    [MoldOrderStatus.ASSESSMENT]: 'amber',
                    [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: 'gray',
                    [MoldOrderStatus.PENDING_REPAIR]: 'gray',
                    [MoldOrderStatus.REPAIR_IN_PROGRESS]: 'amber',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'gray',
                    [MoldOrderStatus.REPORTER_REVIEW]: 'gray',
                    [MoldOrderStatus.PE_RESULT_APPROVAL]: 'gray',
                    [MoldOrderStatus.COMPLETED]: 'green',
                    [MoldOrderStatus.DONE]: 'green',
                    [MoldOrderStatus.END_REJECTED]: 'red',
                }
            },
            actionButtonMapping: {
                [MoldOrderStatus.REPORTER_FILL_FORM]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PENDING_REPAIR]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'เริ่ม Modify',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.REPAIR_IN_PROGRESS]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ],
                },
                [MoldOrderStatus.SUPERVISOR_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
                [MoldOrderStatus.PE_RESULT_APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ],
                },
            },
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.REPORTER_FILL_FORM]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_ACKNOWLEDGE]: 'FileText',
                    [MoldOrderStatus.ASSESSMENT]: 'HardHatIcon',
                    [MoldOrderStatus.PE_ASSESSMENT_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PENDING_REPAIR]: 'FileText',
                    [MoldOrderStatus.REPAIR_IN_PROGRESS]: 'Cog',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.REPORTER_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.PE_RESULT_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                },
            },
            uiConfig: {
                icon: {
                    name: 'Wrench',
                    source: 'lucide',
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
                    textColor: 'text-white',
                    borderColor: 'border-amber-200',
                    shadow: 'shadow-lg shadow-amber-200/50',
                },
                colorCode: 'yellow',
            }
        },
        mold_acceptance: {
            title: 'รับแม่พิมพ์',
            orderTemplateVersion: '1.2',
            formConfigs: formFieldsForMoldAcceptance,
            checkForFormCompletion: true,
            creationConfig: {
                allowedStatuses: ['inactive', 'released_to_external'],
                featureToggle: 'enableMoldAcceptanceCreation',
            },
            moldOrderMainTypes: [],
            moldOrderTypes: [
                MoldOrderType.MOLD_ACCEPTANCE
            ],
            isEnable: true,
            statusMapping: statusLabelsByCompany.sbi.mold_acceptance,
            disallowSetNextAssignee: {
                all: []
            },
            colorCodeMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'blue',
                    [MoldOrderStatus.PENDING_ARRIVAL]: 'blue',
                    [MoldOrderStatus.INITIAL_INSPECTION]: 'amber',
                    [MoldOrderStatus.CLEANING_BEFORE_TESTING]: 'amber',
                    [MoldOrderStatus.PENDING_TESTING]: 'amber',
                    [MoldOrderStatus.DETAILED_INSPECTION]: 'amber',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'gray',
                    [MoldOrderStatus.APPROVAL]: 'gray',
                    [MoldOrderStatus.COMPLETED]: 'green',
                    [MoldOrderStatus.DONE]: 'green',
                    [MoldOrderStatus.END_REJECTED]: 'red',
                }
            },
            actionButtonMapping: {
                [MoldOrderStatus.PENDING_ARRIVAL]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'รับแม่พิมพ์',
                    buttons: []
                },
                [MoldOrderStatus.INITIAL_INSPECTION]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ]
                },
                [MoldOrderStatus.CLEANING_BEFORE_TESTING]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'เสร็จสิ้นการล้าง',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'ViewQuestionnaire',
                    ]
                },
                [MoldOrderStatus.PENDING_TESTING]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'เสร็จสิ้นการทดสอบ',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ]
                },
                [MoldOrderStatus.DETAILED_INSPECTION]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    buttons: [
                        'PrintQRCode',
                        'FillQuestionnaire',
                    ]
                },
                [MoldOrderStatus.SUPERVISOR_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ]
                },
                [MoldOrderStatus.APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire',
                    ]
                },
            },
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_ARRIVAL]: 'TruckIcon',
                    [MoldOrderStatus.INITIAL_INSPECTION]: 'Clock',
                    [MoldOrderStatus.CLEANING_BEFORE_TESTING]: 'Clock',
                    [MoldOrderStatus.PENDING_TESTING]: 'Clock',
                    [MoldOrderStatus.DETAILED_INSPECTION]: 'Cog',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                },
            },
            uiConfig: {
                icon: {
                    name: 'OutlinedMoldIcon',
                    source: 'custom',
                    props: { color: "#2563eb", size: 24, strokeWidth: 60, showHolders: false, activeColor: "#ffffff" },
                    disabledProps: { color: "#9CA3AF", size: 24, strokeWidth: 60, showHolders: false },
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-emerald-500 to-teal-600',
                    textColor: 'text-white',
                    borderColor: 'border-emerald-200',
                    shadow: 'shadow-lg shadow-emerald-200/50',
                },
                colorCode: 'green',
            }
        },
        mold_export: {
            title: 'ส่งออกแม่พิมพ์',
            orderTemplateVersion: '1.0',
            formConfigs: [
                {
                    key: 'expectedExportDate',
                    label: 'กำหนดการส่งคืน (คาดการณ์)',
                    type: 'date',
                    required: true,
                },
                {
                    key: 'rootCause',
                    label: 'สาเหตุที่ส่งออก',
                    type: 'select_with_other_and_custom',
                    options: [],
                    fetch: fetchersRegistry['mold.exportRootCausesList'],
                    required: true,
                },
            ],
            checkForFormCompletion: false,
            creationConfig: {
                allowedStatuses: ['active'],
            },
            moldOrderMainTypes: [],
            moldOrderTypes: [
                MoldOrderType.MOLD_EXPORT
            ],
            isEnable: true,
            statusMapping: statusLabelsByCompany.sbi.mold_export,
            disallowSetNextAssignee: {
                all: [
                    MoldOrderStatus.PENDING_INSPECTION,
                ]
            },
            colorCodeMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'blue',
                    [MoldOrderStatus.PENDING_INSPECTION]: 'amber',
                    [MoldOrderStatus.DETAILED_INSPECTION]: 'amber',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'gray',
                    [MoldOrderStatus.PE_APPROVAL]: 'gray',
                    [MoldOrderStatus.PENDING_EXPORT]: 'gray',
                    [MoldOrderStatus.COMPLETED]: 'green',
                    [MoldOrderStatus.DONE]: 'green',
                    [MoldOrderStatus.END_REJECTED]: 'red',
                }
            },
            actionButtonMapping: {
                [MoldOrderStatus.PENDING_INSPECTION]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'เริ่มการตรวจสอบ',
                    buttons: [
                        'ViewQuestionnaire'
                    ]
                },
                [MoldOrderStatus.DETAILED_INSPECTION]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งใบงาน',
                    buttons: [
                        'FillQuestionnaire',
                    ]
                },
                [MoldOrderStatus.SUPERVISOR_REVIEW]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire'
                    ]
                },
                [MoldOrderStatus.PE_APPROVAL]: {
                    buttonType: 'approval',
                    buttons: [
                        'ViewQuestionnaire'
                    ]
                },
                [MoldOrderStatus.PENDING_EXPORT]: {
                    buttonType: 'submit',
                    customAcceptButtonLabel: 'ส่งออกแม่พิมพ์',
                    customRejectButtonLabel: 'ปิดใบงาน',
                    buttons: [
                        'ViewQuestionnaire'
                    ]
                },
            },
            iconStatusMapping: {
                all: {
                    [MoldOrderStatus.CREATED]: 'SquarePenIcon',
                    [MoldOrderStatus.PENDING_INSPECTION]: 'FileText',
                    [MoldOrderStatus.DETAILED_INSPECTION]: 'Cog',
                    [MoldOrderStatus.SUPERVISOR_REVIEW]: 'FileCheck',
                    [MoldOrderStatus.PE_APPROVAL]: 'FileCheck',
                    [MoldOrderStatus.PENDING_EXPORT]: 'Truck',
                    [MoldOrderStatus.COMPLETED]: 'Check',
                    [MoldOrderStatus.DONE]: 'Check',
                    [MoldOrderStatus.END_REJECTED]: 'X',
                },
            },
            nextStepAction: {
                [MoldOrderStatus.PENDING_EXPORT]: {
                    formConfigs: [
                        {
                            key: 'exportDate',
                            label: 'วันที่ส่งออกจริง',
                            type: 'date',
                            required: true,
                            defaultDateOffset: 0, // Default to today
                        }
                    ]
                }
            },
            uiConfig: {
                icon: {
                    name: 'Truck',
                    source: 'lucide',
                },
                header: {
                    bgColor: 'bg-gradient-to-br from-emerald-500 to-teal-600',
                    textColor: 'text-white',
                    borderColor: 'border-emerald-200',
                    shadow: 'shadow-lg shadow-emerald-200/50',
                },
                colorCode: 'red',
            }
        }
    },
    moldOrderDetail: {
        header: {
            title: 'productParts',
            subtitle: 'moldNumber',
        }
    },
    moldOrderCreation: {
        moldTable: {
            visibleColumns: [
                { key: 'sbiId', label: 'รหัสแม่พิมพ์', sortable: true, filterable: true },
                { key: 'productParts', label: 'รหัสชิ้นงาน', sortable: true, filterable: true },
                { key: 'customer', label: 'ลูกค้า', sortable: true, filterable: true },
                { key: 'moldNumber', label: 'แม่พิมพ์ลูกที่', sortable: true, filterable: true },
                { key: 'status', label: 'สถานะ', sortable: true, filterable: true },
                { key: 'shotCount', label: '#Shot', sortable: false, filterable: false },
            ]
        },
        orderTypes: [
            'mold_acceptance',
            'maintenance',
            'repair',
            'mold_export'
        ],
    },
    kanban: {
        card: {
            title: 'sbiId',
            subtitle: 'productParts',
        },
        boards: {
            data: [
                {
                    key: 'maintenance',
                    group: 'maintenance',
                    moldOrderTypes: [
                        MoldOrderType.ALL_STORE,
                        MoldOrderType.ALL_PRODUCTION,
                        MoldOrderType.WAITING,
                        MoldOrderType.STORE_ORDER_COMPLETE,
                        MoldOrderType.STORE_CLOSE_MOLD,
                        MoldOrderType.STORE_EOL,
                    ],
                    filters: {
                        moldOrderTypeGroups: [
                            {
                                value: MoldOrderMainType.ALL_OVERHAUL,
                                label: 'ล้างทั้งระบบ',
                                subTypes: [
                                    MoldOrderType.ALL_STORE,
                                    MoldOrderType.ALL_PRODUCTION,
                                ]
                            },
                            {
                                value: MoldOrderMainType.PRODUCTION,
                                label: 'ล้างเพื่อผลิต',
                                subTypes: [
                                    MoldOrderType.WAITING,
                                ]
                            },
                            {
                                value: MoldOrderMainType.STORE,
                                label: 'ล้างเพื่อเก็บ',
                                subTypes: [
                                    MoldOrderType.STORE_ORDER_COMPLETE,
                                    MoldOrderType.STORE_CLOSE_MOLD,
                                    MoldOrderType.STORE_EOL,
                                ]
                            },
                        ],
                    },
                    title: 'ล้างแม่พิมพ์',
                    columns: [
                        {
                            id: 'pending-acknowledge',
                            title: 'รอรับใบงาน',
                            statusIds: [
                                MoldOrderStatus.PENDING_ACKNOWLEDGE
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'FileText',
                        },
                        {
                            id: 'pick-up',
                            title: 'รอล้าง',
                            statusIds: [
                                MoldOrderStatus.PICK_UP
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-100/50',
                            icon: 'Clock',
                        },
                        {
                            id: 'in-progress',
                            title: 'กำลังล้าง',
                            statusIds: [
                                MoldOrderStatus.IN_PROGRESS
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-100 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-200',
                            countBg: 'bg-yellow-50',
                            icon: 'Cog',
                        },
                        {
                            id: 'supervisor-review',
                            title: 'รอหัวหน้าช่างอนุมัติ',
                            statusIds: [
                                MoldOrderStatus.SUPERVISOR_REVIEW
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'reporter-confirm',
                            title: 'รอตรวจสอบ',
                            statusIds: [
                                MoldOrderStatus.REPORTER_CONFIRM
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileText',
                        },
                        {
                            id: 'completed',
                            title: 'เสร็จ',
                            statusIds: [
                                MoldOrderStatus.DONE,
                                MoldOrderStatus.END_REJECTED,
                            ],
                            colorCode: 'green',
                            color: 'bg-green-100 text-green-800',
                            textColor: 'text-green-800',
                            hoverColor: 'hover:bg-green-200',
                            countBg: 'bg-green-50',
                            icon: 'Check',
                        },
                    ],
                    isEnable: true,
                    uiConfig: {
                        icon: {
                            name: 'ShieldHalf',
                            source: 'lucide',
                        },
                        header: {
                            bgColor: 'bg-gradient-to-br from-blue-500 to-indigo-600',
                            textColor: 'text-white',
                            borderColor: 'border-blue-200',
                            shadow: 'shadow-lg shadow-blue-200/50',
                        },
                        colorCode: 'blue',
                    },
                    createNewOrderUrl: ROUTES.CREATE_MAINTENANCE_ORDERS,
                },
                {
                    key: 'repair',
                    group: 'repair',
                    moldOrderTypes: [
                        MoldOrderType.REPAIR_MINOR,
                        MoldOrderType.REPAIR_MAJOR,
                        MoldOrderType.MODIFY,
                    ],
                    filters: {
                        moldOrderTypeGroups: [
                            {
                                value: MoldOrderMainType.REPAIR_MINOR,
                                label: 'ซ่อมหน้าเครื่อง',
                                subTypes: [
                                    MoldOrderType.REPAIR_MINOR
                                ]
                            },
                            {
                                value: MoldOrderMainType.REPAIR_MAJOR,
                                label: 'ซ่อมทั่วไป',
                                subTypes: [
                                    MoldOrderType.REPAIR_MAJOR
                                ]
                            },
                            {
                                value: MoldOrderMainType.MODIFY,
                                label: 'Modify แม่พิมพ์',
                                subTypes: [
                                    MoldOrderType.MODIFY
                                ]
                            }
                        ],
                    },
                    title: 'ซ่อม/Modify',
                    columns: [
                        {
                            id: 'reporter-fill-form',
                            title: 'กรอกข้อมูลปัญหา',
                            statusIds: [
                                MoldOrderStatus.REPORTER_FILL_FORM
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'SquarePenIcon',
                        },
                        {
                            id: 'pending-acknowledge',
                            title: 'รอรับใบงาน',
                            statusIds: [
                                MoldOrderStatus.PENDING_ACKNOWLEDGE
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'FileText',
                        },
                        {
                            id: 'assessment',
                            title: 'ประเมินเบื้องต้น',
                            statusIds: [
                                MoldOrderStatus.ASSESSMENT
                            ],
                            colorCode: 'purple',
                            color: 'bg-purple-100 text-purple-800',
                            textColor: 'text-purple-800',
                            hoverColor: 'hover:bg-purple-200',
                            countBg: 'bg-purple-50',
                            icon: 'HardHatIcon',
                        },
                        {
                            id: 'pe-assessment-approval',
                            title: 'วิศวกรประเมิน',
                            statusIds: [
                                MoldOrderStatus.PE_ASSESSMENT_APPROVAL
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'pending-repair',
                            title: 'รอซ่อม/Modify',
                            statusIds: [
                                MoldOrderStatus.PENDING_REPAIR
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-200 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-300',
                            countBg: 'bg-blue-100/50',
                            icon: 'FileText',
                        },
                        {
                            id: 'in-progress',
                            title: 'กำลังซ่อม/Modify',
                            statusIds: [
                                MoldOrderStatus.IN_PROGRESS,
                                MoldOrderStatus.REPAIR_IN_PROGRESS,
                            ],
                            colorCode: 'amber',
                            color: 'bg-yellow-100 text-yellow-800',
                            textColor: 'text-yellow-800',
                            hoverColor: 'hover:bg-yellow-200',
                            countBg: 'bg-yellow-50',
                            icon: 'Cog',
                        },
                        {
                            id: 'supervisor-review',
                            title: 'หัวหน้าช่างอนุมัติ',
                            statusIds: [
                                MoldOrderStatus.SUPERVISOR_REVIEW
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'reporter-confirm',
                            title: 'ผู้แจ้งปัญหาอนุมัติ',
                            statusIds: [
                                MoldOrderStatus.REPORTER_REVIEW,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'pe-result-approval',
                            title: 'วิศวกรอนุมัติ',
                            statusIds: [
                                MoldOrderStatus.PE_RESULT_APPROVAL,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'completed',
                            title: 'เสร็จ',
                            statusIds: [
                                MoldOrderStatus.DONE,
                                MoldOrderStatus.END_REJECTED,
                            ],
                            colorCode: 'green',
                            color: 'bg-green-100 text-green-800',
                            textColor: 'text-green-800',
                            hoverColor: 'hover:bg-green-200',
                            countBg: 'bg-green-50',
                            icon: 'Check',
                        },
                    ],
                    isEnable: true,
                    uiConfig: {
                        icon: {
                            name: 'Wrench',
                            source: 'lucide',
                        },
                        header: {
                            bgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
                            textColor: 'text-white',
                            borderColor: 'border-amber-200',
                            shadow: 'shadow-lg shadow-amber-200/50',
                        },
                        colorCode: 'yellow',
                    },
                    createNewOrderUrl: ROUTES.CREATE_REPAIR_ORDERS,
                },
                {
                    key: 'mold_acceptance',
                    group: 'mold_acceptance',
                    moldOrderTypes: [
                        MoldOrderType.MOLD_ACCEPTANCE
                    ],
                    filters: {
                        moldOrderTypeGroups: [],
                    },
                    title: 'แม่พิมพ์ใหม่',
                    columns: [
                        {
                            id: 'pending-arrival',
                            title: 'รอเข้าโรงงาน',
                            statusIds: [
                                MoldOrderStatus.PENDING_ARRIVAL
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'TruckIcon',
                        },
                        {
                            id: 'initial-inspection',
                            title: 'ตรวจสอบเบื้องต้น',
                            statusIds: [
                                MoldOrderStatus.INITIAL_INSPECTION
                            ],
                            colorCode: 'purple',
                            color: 'bg-purple-100 text-purple-800',
                            textColor: 'text-purple-800',
                            hoverColor: 'hover:bg-purple-200',
                            countBg: 'bg-purple-50',
                            icon: 'Clock',
                        },
                        {
                            id: 'cleaning-before-testing',
                            title: 'ล้างก่อนทดสอบ',
                            statusIds: [
                                MoldOrderStatus.CLEANING_BEFORE_TESTING
                            ],
                            colorCode: 'purple',
                            color: 'bg-purple-100 text-purple-800',
                            textColor: 'text-purple-800',
                            hoverColor: 'hover:bg-purple-200',
                            countBg: 'bg-purple-50',
                            icon: 'Clock',
                        },
                        {
                            id: 'pending-testing',
                            title: 'ทดสอบแม่พิมพ์',
                            statusIds: [
                                MoldOrderStatus.PENDING_TESTING
                            ],
                            colorCode: 'fuchsia',
                            color: 'bg-fuchsia-100 text-fuchsia-800',
                            textColor: 'text-fuchsia-800',
                            hoverColor: 'hover:bg-fuchsia-200',
                            countBg: 'bg-fuchsia-50',
                            icon: 'Clock',
                        },
                        {
                            id: 'detailed-inspection',
                            title: 'ตรวจสอบละเอียด',
                            statusIds: [
                                MoldOrderStatus.DETAILED_INSPECTION
                            ],
                            colorCode: 'indigo',
                            color: 'bg-indigo-100 text-indigo-800',
                            textColor: 'text-indigo-800',
                            hoverColor: 'hover:bg-indigo-200',
                            countBg: 'bg-indigo-50',
                            icon: 'Cog',
                        },
                        {
                            id: 'supervisor-review',
                            title: 'หัวหน้าช่างตรวจสอบ',
                            statusIds: [
                                MoldOrderStatus.SUPERVISOR_REVIEW
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-100/50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'approval',
                            title: 'อนุมัติ',
                            statusIds: [
                                MoldOrderStatus.APPROVAL,
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'completed',
                            title: 'เสร็จ',
                            statusIds: [
                                MoldOrderStatus.DONE, MoldOrderStatus.END_REJECTED
                            ],
                            colorCode: 'green',
                            color: 'bg-green-100 text-green-800',
                            textColor: 'text-green-800',
                            hoverColor: 'hover:bg-green-200',
                            countBg: 'bg-green-50',
                            icon: 'Check',
                        },
                    ],
                    isEnable: true,
                    uiConfig: {
                        icon: {
                            name: 'OutlinedMoldIcon',
                            source: 'custom',
                        },
                        header: {
                            bgColor: 'bg-gradient-to-br from-emerald-500 to-teal-600',
                            textColor: 'text-white',
                            borderColor: 'border-emerald-200',
                            shadow: 'shadow-lg shadow-emerald-200/50',
                        },
                        colorCode: 'green',
                    },
                    createNewOrderUrl: ROUTES.CREATE_MOLD_ACCEPTANCE_ORDERS,
                },
                {
                    key: 'mold_export',
                    group: 'mold_export',
                    moldOrderTypes: [
                        MoldOrderType.MOLD_EXPORT,
                    ],
                    filters: {
                        moldOrderTypeGroups: [],
                    },
                    title: 'ส่งออกแม่พิมพ์',
                    columns: [
                        {
                            id: 'pending-inspection',
                            title: 'รอตรวจสอบ',
                            statusIds: [
                                MoldOrderStatus.PENDING_INSPECTION
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'Clock',
                        },
                        {
                            id: 'detailed-inspection',
                            title: 'ตรวจสอบแม่พิมพ์',
                            statusIds: [
                                MoldOrderStatus.DETAILED_INSPECTION
                            ],
                            colorCode: 'blue',
                            color: 'bg-blue-100 text-blue-800',
                            textColor: 'text-blue-800',
                            hoverColor: 'hover:bg-blue-200',
                            countBg: 'bg-blue-50',
                            icon: 'Cog',
                        },
                        {
                            id: 'supervisor-review',
                            title: 'หัวหน้าช่างอนุมัติ',
                            statusIds: [
                                MoldOrderStatus.SUPERVISOR_REVIEW
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-100/50',
                            icon: 'FileCheck',
                        },
                        {
                            id: 'pe-approval',
                            title: 'PE อนุมัติ',
                            statusIds: [
                                MoldOrderStatus.PE_APPROVAL
                            ],
                            colorCode: 'gray',
                            color: 'bg-gray-200 text-gray-800',
                            textColor: 'text-gray-800',
                            hoverColor: 'hover:bg-gray-300',
                            countBg: 'bg-gray-100/50',
                            icon: 'Clock',
                        },
                        {
                            id: 'pending-export',
                            title: 'รอส่งออก',
                            statusIds: [
                                MoldOrderStatus.PENDING_EXPORT
                            ],
                            colorCode: 'indigo',
                            color: 'bg-indigo-100 text-indigo-800',
                            textColor: 'text-indigo-800',
                            hoverColor: 'hover:bg-indigo-200',
                            countBg: 'bg-indigo-50',
                            icon: 'Truck',
                        },
                        {
                            id: 'completed',
                            title: 'เสร็จ',
                            statusIds: [
                                MoldOrderStatus.DONE, MoldOrderStatus.END_REJECTED
                            ],
                            colorCode: 'green',
                            color: 'bg-green-100 text-green-800',
                            textColor: 'text-green-800',
                            hoverColor: 'hover:bg-green-200',
                            countBg: 'bg-green-50',
                            icon: 'Check',
                        },
                    ],
                    isEnable: true,
                    uiConfig: {
                        icon: {
                            name: 'Truck',
                            source: 'lucide',
                        },
                        header: {
                            bgColor: 'bg-gradient-to-br from-red-500 to-red-600',
                            textColor: 'text-white',
                            borderColor: 'border-red-200',
                            shadow: 'shadow-lg shadow-red-200/50',
                        },
                        colorCode: 'red',
                    },
                    createNewOrderUrl: ROUTES.CREATE_MOLD_EXPORT_ORDERS,
                },
            ],
            defaultBoardKey: 'maintenance',
        }
    },
    dashboard: {
        taskRow: {
            /** Field shown in the third column of TaskRow - uses field renderers */
            infoField: 'productParts', // Will use ProductPartsRenderer for SBI
        },
        // Day shift A (เช้า) = 08:00–20:00, night shift B (ดึก) = the rest.
        shifts: {
            dayStartHour: 8,
            dayEndHour: 20,
        },
    },
    table: {
        moldOrdersColumns: {
            // All columns available for SBI users to choose from in ColumnSelector
            availableColumns: [
                'id',
                'mold',
                'moldNumber',
                'productParts',
                'customer',
                'type',
                'status',
                'priority',
                'assignedTo',
                'assignedTechnician',
                'approvalTechnician',
                'reporterConfirm',
                'createdAt',
                'orderDetail',
                'operationDate',
                'supervisorReviewDate',
                'reporterConfirmationDate',
                'operationDuration',
                'shiftCompleted',
                'machineNumber',
                'rejectedReason',
                'rejectedBy',
                'rejectedState',
                'actions'
            ],
            // Columns shown by default (users can hide/show these)
            defaultVisibleColumns: [
                'id',
                'mold',
                'moldNumber',
                'productParts',
                'customer',
                'type',
                'status',
                'priority',
                'assignedTo',
                'assignedTechnician',
                'approvalTechnician',
                'reporterConfirm',
                'createdAt',
                'orderDetail',
                'operationDate',
                'shiftCompleted',
                'machineNumber',
                'actions'
            ],
            customLabels: {}
        },
        moldOrdersInMoldPageColumns: {
            // All columns available for SBI users to choose from in ColumnSelector
            availableColumns: [
                'id',
                'mold',
                'moldNumber',
                'productParts',
                'type',
                'status',
                'priority',
                'assignedTo',
                'assignedTechnician',
                'approvalTechnician',
                'reporterConfirm',
                'createdAt',
                'orderDetail',
                'operationDate',
                'supervisorReviewDate',
                'reporterConfirmationDate',
                'operationDuration',
                'shiftCompleted',
                'machineNumber',
                'rejectedReason',
                'rejectedBy',
                'rejectedState',
                'actions'
            ],
            // Columns shown by default (users can hide/show these)
            defaultVisibleColumns: [
                'id',
                'mold',
                'moldNumber',
                'productParts',
                'type',
                'status',
                'createdAt',
                'orderDetail',
                'actions'
            ],
            customLabels: {}
        },
        moldColumns: {
            // All columns available for SBI users to choose from in ColumnSelector
            // Grouped to match the MoldDetail page tabs for consistency
            availableColumns: [
                // ข้อมูลทั่วไป
                'sbiId',
                'moldNumber',
                'customer',
                'productParts',
                'status',
                'revision',
                'moldType',
                'moldSource',
                'cavity',
                'makerName',
                'country',
                'plate',
                'gateType',
                'delayGate',
                'hotRunner',
                'hotRunnerType',
                'hotRunnerBrand',
                'qtyZoneHr',
                'partMatGrade',
                'surfaceFinish',
                'remarks',
                // จำนวนชอต
                'shotCount',
                'cycleShotCountDisplay',
                'shotCountDisplay',
                'physicalShotCountDisplay',
                'servicingAlertShotThreshold',
                'servicingMaxShotThreshold',
                'maxShotCount',
                // ขนาด
                'width',
                'height',
                'length',
                'weight',
                'machineSizeMin',
                'machineSizeMax',
                'locatedRingOd',
                'nozzleSr',
                // Insert
                'insertEngraving',
                'insertChangeType',
                // ที่ตั้ง
                'currentLocation',
                'storageLocation',
                'assetNoCustomer',
                // Actions
                'actions'
            ],
            // Columns shown by default (users can hide/show these)
            defaultVisibleColumns: [
                'sbiId',
                'productParts',
                'customer',
                'moldNumber',
                'status',
                'shotCount',
                'actions'
            ],
            customLabels: {
                'sbiId': 'รหัสแม่พิมพ์',
                'productParts': 'รหัสชิ้นงาน',
                'customer': 'ลูกค้า',
                'moldNumber': 'แม่พิมพ์ลูกที่',
                'status': 'สถานะ',
                'shotCount': '#Shot',
                'actions': 'Actions'
            }
        }
    },
    search: {
        moldSearchFields: {
            availableSearchFields: [
                {
                    id: 'all',
                    label: 'ทั้งหมด',
                    placeholder: 'พิมพ์รหัสแม่พิมพ์/Part No.',
                    enabled: true
                },
                {
                    id: 'moldId',
                    label: 'รหัสแม่พิมพ์',
                    placeholder: 'พิมพ์รหัสแม่พิมพ์',
                    enabled: true
                },
                {
                    id: 'partNo',
                    label: 'Part No.',
                    placeholder: 'พิมพ์ Part No.',
                    enabled: true
                },
                {
                    id: 'partName',
                    label: 'ชื่อชิ้นงาน',
                    placeholder: 'พิมพ์ชื่อชิ้นงาน',
                    enabled: true
                },
                {
                    id: 'customer',
                    label: 'ลูกค้า',
                    placeholder: 'พิมพ์ชื่อลูกค้า',
                    enabled: true
                }
            ],
            defaultSearchField: 'all'
        },
        moldOrderSearchFields: {
            availableSearchFields: [
                {
                    id: 'all',
                    label: 'ทั้งหมด',
                    placeholder: 'พิมพ์รหัสใบงาน/รหัสแม่พิมพ์/อื่นๆ เพื่อค้นหา',
                    enabled: true
                },
                {
                    id: 'orderId',
                    label: 'รหัสใบงาน',
                    placeholder: 'พิมพ์รหัสใบงาน',
                    enabled: true
                },
                {
                    id: 'moldId',
                    label: 'รหัสแม่พิมพ์',
                    placeholder: 'พิมพ์รหัสแม่พิมพ์',
                    enabled: true
                },
                {
                    id: 'customerCode',
                    label: 'รหัสลูกค้า',
                    placeholder: 'พิมพ์รหัสลูกค้า',
                    enabled: true
                },
                {
                    id: 'partNo',
                    label: 'รหัส Part',
                    placeholder: 'พิมพ์รหัส Part ที่เกี่ยวข้อง',
                    enabled: true
                },
                {
                    id: 'partName',
                    label: 'ชื่อชิ้นงาน',
                    placeholder: 'พิมพ์ชื่อชิ้นงาน',
                    enabled: true
                },
                {
                    id: 'assignedTo',
                    label: 'ผู้รับผิดชอบ',
                    placeholder: 'พิมพ์ชื่อผู้รับผิดชอบ',
                    enabled: true
                },
                {
                    id: 'type',
                    label: 'ประเภทงาน',
                    placeholder: 'พิมพ์ประเภทงาน',
                    enabled: true
                }
            ],
            defaultSearchField: 'all'
        }
    },
    homepage: {
        workOrderCards: [
            {
                id: 'maintenance',
                title: 'ใบงานล้างแม่พิมพ์',
                subtitle: 'กำลังดำเนินการ',
                disabledSubtitle: 'ยังไม่เปิดใช้งาน',
                show: true,
                route: `${ROUTES.DASHBOARD}?boardType=maintenance`,
            },
            {
                id: 'repair',
                title: 'ใบงานซ่อม/Modify',
                subtitle: 'กำลังดำเนินการ',
                disabledSubtitle: 'ยังไม่เปิดใช้งาน',
                show: true,
                route: `${ROUTES.DASHBOARD}?boardType=repair`,
            },
            {
                id: 'mold_acceptance',
                title: 'ใบงานรับแม่พิมพ์',
                subtitle: 'กำลังดำเนินการ',
                disabledSubtitle: 'ยังไม่เปิดใช้งาน',
                show: true,
                route: `${ROUTES.DASHBOARD}?boardType=mold_acceptance`,
            },
            {
                id: 'mold_export',
                title: 'ใบงานส่งออกแม่พิมพ์',
                subtitle: 'กำลังดำเนินการ',
                disabledSubtitle: 'ยังไม่เปิดใช้งาน',
                show: true,
                route: `${ROUTES.DASHBOARD}?boardType=mold_export`,
            },
        ],
        taskTabs: {
            type: 'defined',
            tabs: [
                {
                    id: 'maintenance',
                    label: 'ล้างแม่พิมพ์',
                    show: true,
                    moldOrderTypes: [
                        MoldOrderType.ALL_STORE,
                        MoldOrderType.ALL_PRODUCTION,
                        MoldOrderType.WAITING,
                        MoldOrderType.STORE_ORDER_COMPLETE,
                        MoldOrderType.STORE_CLOSE_MOLD,
                        MoldOrderType.STORE_EOL,
                    ],
                },
                {
                    id: 'repair',
                    label: 'ซ่อม',
                    show: true,
                    moldOrderTypes: [
                        MoldOrderType.REPAIR_MINOR,
                        MoldOrderType.REPAIR_MAJOR,
                    ],
                },
                {
                    id: 'modify',
                    label: 'Modify',
                    show: true,
                    moldOrderTypes: [
                        MoldOrderType.MODIFY,
                    ],
                },
                {
                    id: 'mold_acceptance',
                    label: 'รับแม่พิมพ์',
                    show: true,
                    moldOrderTypes: [
                        MoldOrderType.MOLD_ACCEPTANCE,
                    ],
                },
                {
                    id: 'mold_export',
                    label: 'ส่งออก',
                    show: true,
                    moldOrderTypes: [
                        MoldOrderType.MOLD_EXPORT,
                    ],
                },
            ]
        }
    }
} as AppState;
